var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.237,
    height: 25.163,
    viewBox: "0 0 26.237 25.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M13.17,24.636H4.1a4.1,4.1,0,0,1-4.1-4.1V4.6A4.1,4.1,0,0,1,4.1.5H22.138a4.1,4.1,0,0,1,4.1,4.1v10.1a1.025,1.025,0,0,1-2.05,0V4.6a2.052,2.052,0,0,0-2.05-2.05H4.1A2.052,2.052,0,0,0,2.05,4.6V20.537a2.052,2.052,0,0,0,2.05,2.05h9.07a1.025,1.025,0,1,1,0,2.05ZM6,19.512a1.025,1.025,0,1,0-1.025,1.025A1.025,1.025,0,0,0,6,19.512Zm4.1,0A1.025,1.025,0,1,0,9.07,20.537,1.025,1.025,0,0,0,10.1,19.512Zm4.1,0a1.025,1.025,0,1,0-1.025,1.025A1.025,1.025,0,0,0,14.195,19.512ZM6,5.624A1.025,1.025,0,1,0,4.971,6.649,1.025,1.025,0,0,0,6,5.624Zm4.1,0A1.025,1.025,0,1,0,9.07,6.649,1.025,1.025,0,0,0,10.1,5.624Zm4.1,0A1.025,1.025,0,1,0,13.17,6.649,1.025,1.025,0,0,0,14.195,5.624Zm4.1,0A1.025,1.025,0,1,0,17.27,6.649,1.025,1.025,0,0,0,18.294,5.624Zm4.1,0a1.025,1.025,0,1,0-1.025,1.025A1.025,1.025,0,0,0,22.394,5.624ZM19.6,25.361l5.464-3.145a2.232,2.232,0,0,0,0-3.87L19.6,15.2a2.239,2.239,0,0,0-3.357,1.935v6.29a2.211,2.211,0,0,0,1.116,1.933,2.22,2.22,0,0,0,2.241,0Zm-1.022-8.384,5.464,3.145a.182.182,0,0,1,0,.317l-5.464,3.145a.181.181,0,0,1-.193,0,.173.173,0,0,1-.092-.158v-6.29a.173.173,0,0,1,.092-.158.181.181,0,0,1,.193,0Zm0,0",
    transform: "translate(0 -0.5)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4cfdedbee09499194079476c726ad0c0.svg";
export { ForwardRef as ReactComponent };